import type { HaNPersonRow } from "@lib/logic";

import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import { PersonCell } from "../PersonCell";
import { useSelectPerson } from "../useSelectPerson";

type PersonRowsProps = {
  people: HaNPersonRow[];
};

// A floor's people. Hovering a person spotlights their desk or area on the map.
export const PersonRows = ({ people }: PersonRowsProps) => {
  const selectPerson = useSelectPerson();

  return (
    <HaNResultList>
      {people.map(row => {
        return (
          <HaNResultList.Item
            key={row.owner.id}
            nodeId={row.reservation.workspace.nodeId}
            selectionId={row.owner.id}
            highlightsOnMapHover={false}
            onSelect={() => selectPerson(row)}>
            <PersonCell row={row} />
          </HaNResultList.Item>
        );
      })}
    </HaNResultList>
  );
};
